import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { PackageCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, formatErr, rupiah } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export const BundleOffers = ({ eventId, refreshKey }) => {
  const [offers, setOffers] = useState([]);
  const [busy, setBusy] = useState(null);
  const { removeMany } = useCart();
  const nav = useNavigate();

  useEffect(() => {
    api.get("/face/bundles", { params: eventId ? { event_id: eventId } : {} }).then((r) => setOffers(r.data)).catch(() => setOffers([]));
  }, [eventId, refreshKey]);

  const buy = async (o) => {
    setBusy(o.event_id);
    try {
      await api.post("/orders/bundle", { event_id: o.event_id });
      removeMany(o.photo_ids);
      toast.success("Pesanan paket dibuat. Silakan transfer & unggah bukti.");
      nav("/pesanan");
    } catch (e) {
      toast.error(formatErr(e));
    } finally {
      setBusy(null);
    }
  };

  if (!offers.length) return null;
  return (
    <div className="space-y-3 mb-8" data-testid="bundle-offers">
      {offers.map((o) => (
        <div key={o.event_id} className="rounded-2xl border border-blue-200 bg-blue-50/60 p-5 flex flex-col sm:flex-row sm:items-center gap-4 fade-up" data-testid={`bundle-offer-${o.event_id}`}>
          <span className="h-11 w-11 shrink-0 rounded-xl bg-blue-600 text-white grid place-items-center"><PackageCheck className="h-5 w-5" /></span>
          <div className="flex-1">
            <p className="text-xs uppercase tracking-widest text-blue-700 font-bold">Paket hemat</p>
            <p className="font-bold text-zinc-900">Semua {o.available_count} foto wajahmu di {o.event_title}</p>
            <p className="text-sm text-zinc-600">
              <span className="line-through text-zinc-400 mr-2">{rupiah(o.regular_total)}</span>
              <span className="font-mono-x font-semibold text-zinc-900" data-testid={`bundle-charge-${o.event_id}`}>{rupiah(o.charge)}</span>
              <span className="ml-2 text-emerald-700 font-semibold">hemat {rupiah(o.regular_total - o.charge)}</span>
            </p>
          </div>
          <Button onClick={() => buy(o)} disabled={busy === o.event_id} className="rounded-xl bg-blue-600 hover:bg-blue-700 h-11" data-testid={`bundle-buy-${o.event_id}`}>
            {busy === o.event_id ? "Memproses..." : "Beli paket"}
          </Button>
        </div>
      ))}
    </div>
  );
};
